import { Info } from "lucide-react";
import { PARTNER_PROGRAM_CHANGE_DATE } from "@/lib/constants";

const UpdateNoticeSection = () => (
  <section id="update-hinweis" className="border-y border-primary/20 bg-primary/5 py-8 md:py-10">
    <div className="container">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-2xl border border-border/60 bg-card/80 p-4 sm:p-5">
        <div className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary">
          <Info className="h-4 w-4" aria-hidden="true" />
        </div>
        <div className="text-sm leading-relaxed text-muted-foreground sm:text-base">
          <p className="font-display text-sm font-semibold text-foreground sm:text-base">
            Update ab {new Date(PARTNER_PROGRAM_CHANGE_DATE).toLocaleDateString("de-DE")}
          </p>
          <p className="mt-1.5">
            heilys hat sein Partnerprogramm umgestellt. Sämtliche Konditionen werden ausschließlich zentral
            über den offiziellen heilys Shop geregelt und gelten dort für alle Kunden gleichermaßen. Diese
            Seite bleibt eine unabhängige Informationsquelle zu Produkten und Anwendung. Wenn du über den
            Partnerlink bestellst, unterstützt du unsere Arbeit – für dich entstehen dadurch keine
            Mehrkosten.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default UpdateNoticeSection;
